import { getTranslation } from '@easy-expense/intl-client';
import type { TeamPlanCode } from '@easy-expense/utils-shared';

export type {
  BillingTerm,
  BusinessPlanCode,
  IndividualPlanCode,
  PaddleExistingItemsPricings,
  PaddleIndividualItemsPricings,
  PaddleItemsPricings,
  PaddleNewItemsPricings,
  TeamPlanCode,
} from '@easy-expense/utils-shared';

export {
  individualPlanFromPriceID,
  individualPlanSeats,
  isExistingTeamPriceID,
  paddleBusinessItemsProd,
  paddleBusinessItemsSandbox,
  paddleIndividualItemsProd,
  paddleIndividualItemsSandbox,
  paddleTeamItemsExistingAnnualProd,
  paddleTeamItemsExistingAnnualSandbox,
  paddleTeamItemsExistingMonthlyProd,
  paddleTeamItemsExistingMonthlySandbox,
  paddleTeamItemsNewAnnualProd,
  paddleTeamItemsNewAnnualSandbox,
  paddleTeamItemsNewMonthlyProd,
  paddleTeamItemsNewMonthlySandbox,
  priceIsAnnual,
  teamPlanFromPriceID,
} from '@easy-expense/utils-shared';

export const paddleClientTokenProd = 'live_845f6bbf84676f9f51709dd1664';
export const paddleClientTokenSandbox = 'test_233ce5f6334d8e4b9a658161096';

export function getTeamPlanTitle(plan: TeamPlanCode): string {
  if (plan === 'TEAMS_PRO') {
    return getTranslation('Teams Pro');
  }
  return getTranslation('Team');
}
